module.exports = __webpack_public_path__ + "static/media/withdraw_bank.70fcd7f3.mp3";